import pdfMake from 'pdfmake/build/pdfmake.js';
import getBase64ImageFromURL from '../../../../ClinicEvent/components/PdfReports/GetImage';
import moment from 'moment';

const labReport = async (data) => {

    pdfMake.fonts = {
        OpenSans: {
          normal: 'OpenSans-Regular.ttf',
          bold: 'OpenSans-Bold.ttf',
          italics: 'OpenSans-Italic.ttf',
          bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
          },
          Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
          }
      };

    //console.log(data);

    const urlLogo = process.env.REACT_APP_PUBLIC_URL + "clinica/" + data.clinic.id_clinica + "/logo/" + sessionStorage.getItem('token')

    const date = moment(new Date()).format('L');

    const tiempo = moment(data.patient.fec_nacimiento, "YYYYMMDD").fromNow();

    const edad = tiempo.substr(5, (tiempo.length - 1))

    const header = {
        margin: [40, 10, 0, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', '*'],
            body: [
                [{
                    image: await getBase64ImageFromURL(urlLogo),
                    fit: [150, 150],                    
                },
                { text: "Resultados Exámenes", style: 'tableheader' }],
            ]
        },
    };

    const foter = {
        margin: [20, 0, 0, 0],
        text: data.clinic.nombre + " " + data.clinic.direccion.direccion + " Tel: " + data.clinic.telefono1 + "\n Impreso por software SAC", style: 'head',
    };

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        header: header,
        footer: foter,
        info: {
            author: "Josue Hurtado",
        },
        content: [
            {
                margin: [0, 30, 0, 0],
                layout: 'noBorders', // optional
                table: {
                    widths: ['*', '*'],
                    body: [
                        [{ text: 'Nombre: ' + data.patient.nombres+ " " + data.patient.apellido1 + " " + data.patient.apellido2  , style: 'tableHead' }, 
                        { text: 'Fecha: ' + date, style: 'tableHead' } ],
                        [{ text: 'Documento: ' + data.patient.tip_documento + " " + data.patient.num_documento , style: 'tableHead' }, { text: 'Teléfono: ' + data.patient.celular, style: 'tableHead' }],
                        [{ text: 'Edad - Sexo: ' + edad + " - " + data.patient.sexo, style: 'tableHead' },
                        { text: 'Medico: ' + data.professional.nombres+ " " + data.professional.apellido1 + " " + data.professional.apellido2  , style: 'tableHead' } 
                         ],
                    ]
                },
            },
            {
                margin: [0, 20, 0, 10],
                text: 'Resultados Exámenes ', style: 'title'
            },
            {
                margin: [0, 20, 0, 10],
                text: data.results, style: 'textStyle'
            },
            {
                margin: [0, 80, 0, 10],
                text: data.notes, style: 'textStyle',alignment: 'center'
            },
        ],
        styles: {
            head: {
                fontSize: 10,                
                alignment: 'center'
            },
            tableheader: {
                fontSize: 12,
                bold: true,

            },
            title: {
                fontSize: 15,
                bold: true,
                alignment: 'center'
            },
            textStyle: {
                fontSize: 12,
                
            },  
            tableHead: {
                fontSize: 12,
                bold: true
            },  
                     
        }
    }

    pdfMake.createPdf(documentDefinition).open();

}

export default labReport;